/**
 * Dosimetry report snapshot template.
 *
 * Defines the captures to include on the snapshot page of the dosimetry report.
 */

import type { IReportSnapshotTemplate } from '@/components/report';
import { ViewMode } from '@/visualization/display/types';

/**
 * The dosimetry workflow does not use sizing measurements, so no `measurementId`
 * is needed — captures show the liver segmentation and tumors as-is.
 *
 * To add or remove captures: edit this constant only — no other file needs changing.
 */
export const DOSIMETRY_SNAPSHOT_TEMPLATE: IReportSnapshotTemplate = {
    id: 'dosimetry-report',
    configs: [
        {
            id: '3d-anterior',
            label: 'Vue 3D antérieure',
            viewMode: ViewMode.VIEW_3D,
            size: { width: 500, height: 500 },
        },
        {
            id: '2d-axial',
            label: 'Coupe axiale',
            viewMode: ViewMode.VIEW_2D_AXIAL,
            size: { width: 400, height: 400 },
        },
        {
            id: '2d-sagittal',
            label: 'Coupe sagittale',
            viewMode: ViewMode.VIEW_2D_SAGITTAL,
            size: { width: 400, height: 400 },
        },
        {
            id: '2d-coronal',
            label: 'Coupe coronale',
            viewMode: ViewMode.VIEW_2D_CORONAL,
            size: { width: 400, height: 400 },
        },
    ],
};
